import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, map } from 'lodash';

import Button from 'components/CustomButtons/Button.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import PageContent from 'components/PageContent/PageContent';
import PageContentBody from 'components/PageContent/PageContentBody';
import PageContentHeader from 'components/PageContent/PageContentHeader';
import CompanyCard from 'components/Staffing/Companies/CompanyCard';
import CompaniesFilter from 'components/Staffing/Companies/CompaniesFilter';
import AddCompanyDialog from 'components/Dialogs/Staffing/AddCompanyDialog';

import { openCreateCompanyDialog } from 'redux/actions/staffingActions';
import { selectCompaniesList } from 'redux/selectors/staffing/getCompanies';

const useStyles = makeStyles({
  pageHeader: {},
  // 10px per side = 20px between cards horizontally. Matching 20px below each item
  // so row gaps equal column gaps. Flex stretch so cards in a row share the tallest height.
  cardsGrid: {
    alignItems: 'stretch',
  },
  gridItem: {
    padding: '0 10px 20px !important',
    display: 'flex',
    flexDirection: 'column',
  },
  // Same 10px horizontal padding as cards so the search's left edge matches the first card.
  filterGridItem: {
    padding: '0 10px !important',
  },
  createCompanyButton: {
    height: 36,
  },
});

/**
 * Staffing admin Companies list. Data comes from the Firestore `companies` listener already
 * started in Staffing.js (same pattern as Deals/Projects — not the paginated API list).
 */
const CompaniesList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const getAllCompanies = selectCompaniesList();
  const { companies, isLoaded, hasSearch } = useSelector(state => getAllCompanies(state));

  const openCreateCompany = () => dispatch(openCreateCompanyDialog(true));

  if (!isLoaded) {
    return null;
  }

  return (
    <div>
      <GridContainer direction="row" justify="center" alignItems="center">
        <GridItem xs={12}>
          <PageContent>
            <PageContentHeader className={classes.pageHeader}>
              <Typography variant="h5" className="page-content-title">
                Companies
              </Typography>
              <div className="right-col">
                <Button
                  color="primary"
                  onClick={openCreateCompany}
                  size="sm"
                  className={classes.createCompanyButton}
                >
                  New Company
                </Button>
              </div>
            </PageContentHeader>
            <PageContentBody>
              <GridContainer className={`w-100 m-0 ${classes.cardsGrid}`}>
                <GridItem xs={12} className={classes.filterGridItem}>
                  <CompaniesFilter />
                </GridItem>
                {isEmpty(companies) ? (
                  <Typography style={{ fontSize: 18 }} className="w-100 text-center ml-2 mt-4">
                    {hasSearch ? 'No companies match your search' : 'No companies yet'}
                  </Typography>
                ) : null}

                {map(companies, (company, idx) => {
                  return (
                    <GridItem
                      xs={12}
                      sm={4}
                      md={4}
                      lg={4}
                      key={company.id || `company-card-${idx}`}
                      className={classes.gridItem}
                    >
                      <CompanyCard id={company.id} />
                    </GridItem>
                  );
                })}
              </GridContainer>
            </PageContentBody>
          </PageContent>
        </GridItem>
      </GridContainer>

      <AddCompanyDialog />
    </div>
  );
};

export default CompaniesList;
